import React from 'react';

import ReportWidgetCard from './ReportWidgetCard';
import ScheduleDemo from './ScheduleDemo';

const ErrorScreen = () => (
  <ReportWidgetCard className="error-screen">
    <div className="error-screen__image" />

    <p className="error-screen__text">Something went wrong. Please try again later.</p>

    <ScheduleDemo title="Need Your Data Now?" className="error-screen__demo" />
  </ReportWidgetCard>
);

export default ErrorScreen;
